// extracted by mini-css-extract-plugin
export default {"main":"HeaderAccount_main__Blbz1","container":"HeaderAccount_container__dcoIt"};